export const DESIGN_QUERY_SHOW_ALL_SETTINGS = "showAllSettings";
export const DESIGN_QUERY_TAB = "tab";
export const DESIGN_TAB_TRIGGER_MENU = 'button-menu';
export const DESIGN_TAB_WIDGET_MENU = 'widget-menu';


export const ADD_TRIGGER_MENU_ITEM_EVENT = "addTriggerMenuEvent";
export const ADD_WIDGET_MENU_ITEM_EVENT = "addWidgetMenuEvent";

